import React, {
  useEffect,
  useContext,
  useState,
  useCallback,
} from 'react';
import get from 'lodash/get';
import { TabPanel, Tabs, Viewer } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import { Context } from './store';
import { SubHeader } from './HelpContentsPage';

const FtDownloads = ({ data }) => {
  if (!Array.isArray(data) || data.length < 1) return null;
  const dom = data.map((item, index) => (
    <div key={index}>
      <a target="_blank" href={item.url} rel="noreferrer">
        <i className="spaui-icon icon-download-hover" />
        { item.name }
      </a>
    </div>
  ));
  return (<div className="ft-download">{ dom }</div>);
};

const DetailContent = ({ data, noHd }) => (
  <React.Fragment>
    { !noHd && (<p className="des-hd">{ data.title }</p>) }
    <div className="des-bd" dangerouslySetInnerHTML={{ __html: data.content }} />
    <FtDownloads data={data.attachments} />
  </React.Fragment>
);

export const Detail = ({ id }) => {
  const { state } = useContext(Context);
  const [data, setData] = useState([]);
  const [tab, setTab] = useState(null);
  const [image, setImage] = useState('');

  const getDetailContent = useCallback(() => {
    if (!id) return;

    const getDefaultTab = data => get(data, '[0].post_id');

    RPCFactory.quickHelp
      .getPostList(id)
      .done((res) => {
        if (Array.isArray(res)) {
          setTab(getDefaultTab(res));
          setData(res);
          return;
        };
        setData([]);
      })
      .fail((_, msg) => alert(msg));
  }, [id]);

  const setImgSize = (width, height) => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const result = { width, height };

    if (windowWidth < width + 100 || windowHeight < height + 100) {
      if (height / width < windowHeight / windowWidth) {
        result.width = windowWidth - 100;
        result.height = ((windowWidth - 100) / width) * height;
      } else {
        result.height = windowHeight - 100;
        result.width = ((windowHeight - 100) / height) * width;
      }
    }

    return result;
  };

  const handleTabChange = (e, value) => setTab(value);

  const handleCloseImageView = () => setImage('');

  useEffect(() => {
    if (data.length < 1) return;
    if (data.length > 1 && !tab) return;

    const previewImage = ({ target }) => {
      setImage(target.src);
    };
    const imgs = document.querySelectorAll('.des-inner img');
    const links = document.querySelectorAll('.des-inner a');
    for (const img of imgs) {
      img.addEventListener('click', previewImage);
    }
    for (const link of links) {
      link.setAttribute('target', '_blank');
    }

    return () => {
      for (const img of imgs) {
        img.removeEventListener('click', previewImage);
      }
    };
  }, [tab, data]);

  useEffect(getDetailContent, [getDetailContent]);

  let body = null;

  if (data.length === 1) {
    body = (
      <div className="des-inner">
        <DetailContent data={data[0]} />
      </div>
    );
  } else if (data.length > 1) {
    const tabDoms = data.map((item) => (
      <TabPanel tab={item.title} name={item.post_id} key={item.post_id}>
        <DetailContent noHd data={item} />
      </TabPanel>
    ));

    body = (
      <div className="des-inner">
        <p className="des-hd">{ state.detailItem.title }</p>
        <Tabs onChange={handleTabChange} value={tab}>
          { tabDoms }
        </Tabs>
      </div>
    );
  }

  return (
    <div className="help-des">
      <SubHeader />
      { body }
      <Viewer
        type="image"
        setSize={setImgSize}
        show={!!image}
        url={image}
        onClose={handleCloseImageView}
      />
    </div>
  );
};

export default Detail;
